import { z } from "zod"

export const POST_LIMITS = {
	title: 255,
	shortDescription: 500,
	description: 4096,
} as const

/**
 * Форма материала. Заголовок обязателен всегда: без него пост не выйдет в приложения
 * и его не найти в списке. Где материал показывается, решается отдельно, на экране
 * публикации, поэтому переключателя видимости в форме нет.
 */
export const postFormSchema = z.object({
	title: z
		.string()
		.max(POST_LIMITS.title, `Не длиннее ${POST_LIMITS.title} символов`)
		.refine((value) => value.trim().length > 0, "Добавьте заголовок: по нему материал найдут в каталоге"),
	shortDescription: z
		.string()
		.max(POST_LIMITS.shortDescription, `Не длиннее ${POST_LIMITS.shortDescription} символов`),
	description: z
		.string()
		.max(POST_LIMITS.description, `Telegram не примет больше ${POST_LIMITS.description} символов`),
	formatIds: z.array(z.string()),
	nicheIds: z.array(z.string()),
	topicIds: z.array(z.string()),
	durationIds: z.array(z.string()).max(1, "Длительность одна"),
})

/** Parsed/validated shape of the admin post form data. */
export type PostFormData = z.infer<typeof postFormSchema>
